// extracted by mini-css-extract-plugin
export default {"banner":"VerifyEmailBanner_banner__bVVp6","text":"VerifyEmailBanner_text__L0BqY","button":"VerifyEmailBanner_button__YOYBm","sent":"VerifyEmailBanner_sent__I9ekD"};